function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FileNotFoundError, FileUtils } from '@deephaven/file-explorer';
import MockFileStorageTable from "./MockFileStorageTable.js";
export class MockFileStorage {
  constructor(items) {
    _defineProperty(this, "items", void 0);
    this.items = items;
  }
  getTable() {
    var _this = this;
    return _asyncToGenerator(function* () {
      return new MockFileStorageTable(_this.items);
    })();
  }

  /* eslint-disable class-methods-use-this */
  saveFile(file) {
    throw new Error('Method not implemented.');
  }
  loadFile(name) {
    throw new Error('Method not implemented.');
  }
  copyFile(name, newName) {
    return _asyncToGenerator(function* () {
      throw new Error('Method not implemented.');
    })();
  }
  deleteFile(name) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      _this2.items = _this2.items.filter(value => value.filename !== name);
    })();
  }
  moveFile(name, newName) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      for (var i = 0; i < _this3.items.length; i += 1) {
        if (_this3.items[i].filename === name) {
          _this3.items[i].filename = newName;
          _this3.items[i].basename = FileUtils.getBaseName(newName);
          _this3.items[i].id = newName;
          break;
        }
      }
    })();
  }
  info(name) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      var allItems = _this4.items.filter(value => value.filename === name);
      if (allItems.length === 0) {
        throw new FileNotFoundError();
      }
      if (allItems.length > 1) {
        throw new Error('More than one matching file found');
      }
      var itemDetails = allItems[0];
      return {
        filename: itemDetails.filename,
        basename: itemDetails.basename,
        id: itemDetails.filename,
        type: itemDetails.type
      };
    })();
  }
  createDirectory(name) {
    throw new Error('Method not implemented.');
  }
}
export default MockFileStorage;
//# sourceMappingURL=MockFileStorage.js.map